import { Controller } from "@hotwired/stimulus";

/*
  Controller to handle rule rows for custom columns for the Generic Mapper UI
*/
export default class extends Controller {
  static values = { table: String };
  static targets = ["grid", "rules", "template", "rule_template", "columnNameInput"];

  add() {
    const rawName = this.columnNameInputTarget.value.trim();
    if (!rawName) return;

    const columnName = rawName
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");

    if (!columnName) return;if (this.columnExists(columnName)) {
      alert(`Column "${columnName}" already exists`);
      return;
    }

    if (this.columnExists(columnName)) {
    alert(`Column "${columnName}" already exists`);
    return;
  }
    const fragment = this.templateTarget.content.cloneNode(true);

    fragment.firstElementChild.innerHTML = fragment.firstElementChild.innerHTML.replaceAll("__COLUMN_NAME__", columnName);

    this.gridTarget.appendChild(fragment);

    // reset input
    this.columnNameInputTarget.value = "";
  }

  add_rule_row() {
    const fragment = this.rule_templateTarget.content.cloneNode(true);
    this.rulesTarget.appendChild(fragment);
  }

  remove(event) {
    const row = event.target.closest(".column-row");
    if (row) row.remove();
  }

  columnExists(name) {
    return this.gridTarget.querySelector(
      `.column-row[data-column="${name}"]`
    );
  }
}
